import {I18n} from '@aws-amplify/core';
import {SimplePageHeader} from '@flexinet/ui-components';

import {useAllowedActions} from '../../../hooks/useAllowedActions';
import {AddRecordButton} from '../buttons/AddRecordButton';
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton';
import config from '../config';

const useTools = () => {
    const {allowedActions} = useAllowedActions();

    const tools = [
        <ReloadRecordsButton key='reload'/>,
    ];

    // Hidden, not disabled, when the operator cannot create.
    if (allowedActions.includes('CreateProduct')) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools()}
        />
    );
};
